<template>
    <div :width="width" class="Aside">
        <el-tree ref="tree" :data="data"
                 :props="treeConfig"
                 highlight-current
                 :node-key="nodeKey"
                 :default-expanded-keys="expandedKeys"
                 @node-click="selTree">
      <span slot-scope="{node,data}" class="tree-node">
        <span>{{ data[treeConfig.label] }}</span>
      </span>
        </el-tree>
    </div>
</template>

<script>
    export default {
        name: "tree",
        props: ['data', 'treeConfig', 'width', 'expandedKeys', 'nodeKey'],
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            // 节点点击事件
            selTree(data) {
                this.$emit('selTree', data)
            },
            setkey(key) {
                this.$nextTick(() => {
                    this.$refs.tree.setCurrentKey(key)
                })
            }
        }
    }
</script>

<style scoped>
    .Aside {
        position: relative;
        width: auto !important;
    }


    /deep/ .el-tree-node .el-tree-node__expand-icon {
        margin-right: 5px;
        height: 5px;
        width: 5px;
        background: url(../../../assets/zTreeStandard.png) no-repeat;
        background-position: -110px 0px;
    }

    /deep/ .el-tree-node .is-leaf {
        margin-right: 5px;
        height: 5px;
        width: 5px;
        background: url(../../../assets/zTreeStandard.png) no-repeat;
        background-position: -110px -16px;
    }


    /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #409eff;
        border-radius: 10px;
        color: white;
    }

    /deep/ .el-tree-node__content {
        position: relative;
        width: auto;
        padding: 5px;
        text-align: center;
        cursor: pointer;
        color: black;
    }

    /deep/ .el-tree-node__content .el-tree-node__expand-icon {
        margin-left: 10px;
        font-size: 0px;
    }

    /deep/ .el-tree-node__content:after {
        content: '';
        position: absolute;
        left: 0;
        top: 1px;
        bottom: 1px;
        width: 0;
        z-index: -2;
        border-radius: 10px;
    }

    /deep/ .el-tree-node__content:before {
        content: '';
        position: absolute;
        left: 0;
        top: 1px;
        bottom: 1px;
        width: 0;
        z-index: -2;
        border-radius: 10px;
    }

    /deep/.el-tree-node__content:hover {
        z-index: 1;
        background: transparent;
    }

    /deep/ .el-tree-node__content:before {
        transition: .5s;
        background: #409eff;
        z-index: -1;
    }

    /deep/ .el-tree-node__content:hover:after {
        width: 100%;
    }

    /deep/ .el-tree-node__content:hover:before {
        width: 100%;
    }
</style>